import { render, staticRenderFns } from "./pInviteForm.vue?vue&type=template&id=265ebc83&scoped=true&"
import script from "./pInviteForm.vue?vue&type=script&lang=js&"
export * from "./pInviteForm.vue?vue&type=script&lang=js&"
import style0 from "./pInviteForm.vue?vue&type=style&index=0&id=265ebc83&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265ebc83",
  null
  
)

export default component.exports